import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription, forkJoin } from "rxjs";

//Libraries
import * as _ from "underscore";

// Services
import { CashbackPromoService } from "src/app/modules/rewards/services/cashback-promo.service";
import { GameGroupsService } from "src/app/modules/game-groups/services/game-groups.service";
import { TranslationService } from "src/app/modules/shared/services/translation.service";
import { UserDetailsService } from "src/app/modules/user/services/user-details.service";
import { CashierService } from "src/app/modules/account/services/cashier.service";
import { RewardsService } from "src/app/modules/rewards/services/reward.service";
import { CommonService } from "src/app/modules/shared/services/common.service";
import { UtilityService } from "src/app/utility/utility.service";

@Component({
  selector: "app-all-rewards",
  templateUrl: "./all-rewards.component.html",
  styleUrls: ["./all-rewards.component.scss"],
})
export class AllRewardsComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  activeBonusSub: Subscription;
  bonusDetails: any;
  depositBonus: any;
  finalFilteredBonusData = [];
  currencyCode: string;
  unClaimedLevels: any;
  langCodeSub: Subscription;
  langCode: string;
  currentLevelUpDetails: any;
  gameGroupGameSub: Subscription;
  games: any;
  currencyCodeSub: Subscription;
  promoRaceInfoList: any;

  constructor(
    private utility: UtilityService,
    private commonService: CommonService,
    private translationService: TranslationService,
    private userDetailsService: UserDetailsService,
    private cashierService: CashierService,
    private rewardsService: RewardsService,
    private gameGroupsService: GameGroupsService,
    private cashBackPromoService: CashbackPromoService
  ) {
    this.getAllAvailableBonus();
    this.currencyCodeSub = this.userDetailsService.currencyCodeSb$.subscribe(
      (curreny) => {
        this.currencyCode = curreny;
      }
    );
    this.langCodeSub = this.translationService.langCodeSb$.subscribe(
      (langcode) => {
        this.langCode = langcode;
      }
    );
  }

  ngOnInit() {}

  getAllAvailableBonus(isRefreshRequired = true) {
    if (isRefreshRequired) {
      this.isLoading = true;
    }
    this.finalFilteredBonusData = [];
    forkJoin([
      this.cashBackPromoService.getUserCampaigns(),
      this.rewardsService.getActiveBonusDetails(),
      this.cashierService.getEligibleBonus({ criteriaType: "DEPOSIT" }),
      this.rewardsService.getUnclaimedLevels(),
      this.rewardsService.getUserLevelupDetails(),
    ]).subscribe(
      ([
        promoRaceInfoList,
        activeBonusResp,
        eligibleDespositBonusResp,
        unClaimedLevelsResp,
        currentLevelupDetails,
      ]) => {
        if (
          promoRaceInfoList &&
          promoRaceInfoList["campaignDetails"] &&
          promoRaceInfoList["status"] === "SUCCESS"
        ) {
          this.promoRaceInfoList = promoRaceInfoList["campaignDetails"];
          this.promoRaceInfoList = this.promoRaceInfoList.filter((data) => {
            let currentTime = new Date();
            let promoStartTime = new Date(data["campaignStartDate"]);
            let promoOfferExpiryDate = new Date(data["campaignEndDate"]);
            if (
              data &&
              data["campaignType"] === "CASHBACK_PROMO" &&
              data["optInRequired"] &&
              !data["playerOptinTime"] &&
              currentTime >= promoStartTime &&
              currentTime < promoOfferExpiryDate
            ) {
              data["bonusTypeFD"] = "cashback-promotion";
              return data;
            }
          });
          if (this.promoRaceInfoList && this.promoRaceInfoList.length > 0) {
            this.finalFilteredBonusData.push(this.promoRaceInfoList);
            this.finalFilteredBonusData = _.flatten(
              this.finalFilteredBonusData
            );
          }
        }
        if (activeBonusResp && activeBonusResp.length > 0) {
          this.bonusDetails = activeBonusResp;
          this.bonusDetails = this.bonusDetails.filter((bonus) => {
            if (bonus.isFreeSpinBonus && !bonus.isFreeSpinsCompleted) {
              bonus["bonusTypeFD"] = "freeSpin-bonus";
              return bonus;
            }
          });
          if (this.bonusDetails && this.bonusDetails.length > 0) {
            this.finalFilteredBonusData.push(this.bonusDetails);
            this.finalFilteredBonusData = _.flatten(
              this.finalFilteredBonusData
            );
          }
        }
        if (
          eligibleDespositBonusResp &&
          eligibleDespositBonusResp["status"] === "SUCCESS" &&
          eligibleDespositBonusResp["eligibleBonusList"]
        ) {
          this.depositBonus = eligibleDespositBonusResp["eligibleBonusList"];
          this.depositBonus = this.rewardsService.filterEligibleBonusBasedOnFlow(
            this.depositBonus,
            this.currencyCode,
            this.utility.isPnpFlow()
          );

          if (this.depositBonus && this.depositBonus.length > 0) {
            this.finalFilteredBonusData.push(this.depositBonus);
            this.finalFilteredBonusData = _.flatten(
              this.finalFilteredBonusData
            );
          }
        }
        if (
          this.finalFilteredBonusData &&
          this.finalFilteredBonusData.length > 0
        ) {
          this.getGameGroupGames(false);
        }
        if (
          unClaimedLevelsResp &&
          unClaimedLevelsResp["status"] === "SUCCESS" &&
          unClaimedLevelsResp["unclaimedLevels"].length > 0
        ) {
          this.unClaimedLevels = unClaimedLevelsResp["unclaimedLevels"];
          this.unClaimedLevels = _.map(
            this.unClaimedLevels,
            (unclaimlevelId) => {
              return {
                bonusTypeFD: "unclaimedFreeSpin-bonus",
                levelId: unclaimlevelId,
              };
            }
          );
          if (this.unClaimedLevels && this.unClaimedLevels.length > 0) {
            this.finalFilteredBonusData.push(this.unClaimedLevels);
          }
        }
        if (
          currentLevelupDetails &&
          currentLevelupDetails["status"] === "SUCCESS"
        ) {
          this.currentLevelUpDetails = currentLevelupDetails;
          this.currentLevelUpDetails["bonusTypeFD"] = "upcoming-bonus";
          this.finalFilteredBonusData.push(this.currentLevelUpDetails);
        }
        this.finalFilteredBonusData = _.flatten(this.finalFilteredBonusData);
        this.isLoading = false;
      }
    );
  }

  getGameGroupGames(isForce) {
    this.gameGroupGameSub = this.gameGroupsService
      .getGameGroupGames(isForce)
      .subscribe((games) => {
        if (games && games.length > 0) {
          this.games = games;
          this.finalFilteredBonusData = this.finalFilteredBonusData.filter(
            (data, bindex) => {
              if (
                data["freeSpinGameIds"] &&
                data["freeSpinGameIds"].length > 0
              ) {
                let filteredGame = _.findWhere(games, {
                  gameCode: data["freeSpinGameIds"][0],
                });
                if (filteredGame && Object.keys(filteredGame).length > 0) {
                  data["gameData"] = filteredGame;
                }
              } else if (data["gameIds"] && data["gameIds"].length > 0) {
                let filteredGame = _.findWhere(games, {
                  gameCode: data["gameIds"][0],
                });
                if (filteredGame && Object.keys(filteredGame).length > 0) {
                  data["gameData"] = filteredGame;
                }
              }
              return data;
            }
          );
        }
      });
  }

  reloadActiveBonus() {
    this.getAllAvailableBonus(false);
  }

  openRewardTCPopUp(event) {
    if (event) {
      event.stopPropagation();
    }
    this.utility.toggleRewardTCPopUp(true);
  }

  ngOnDestroy() {
    this.currencyCodeSub.unsubscribe();
    this.langCodeSub.unsubscribe();
    if (this.gameGroupGameSub) {
      this.gameGroupGameSub.unsubscribe();
    }
    if (this.activeBonusSub) {
      this.activeBonusSub.unsubscribe();
    }
  }
}
